import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import * as URLConfig from "@frameworks/web/config/domain";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useSelector } from "react-redux";
const config = URLConfig.config;
const SupportContent = (props) => {
    const device = DeviceContext();
    const onSelectOption = () => {
        di.login.flushLoginError();
        props.setOpenPopup(false);
    };
    const [userType, setUserType] = useState();
    const [userID, setUserID] = useState();
    const userId = useSelector((state) => state.accountDetailsReducer.userID);
    const guestUserID = useSelector((state) => state.LoginFlow.guestValidateMPIN.data.guestId);
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        if (!!guestUserID) {
            setUserType(ILoginFlows.GUEST);
            setUserID(guestUserID);
        }
    };
    useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: ` ${DeviceContext().isDesktop
                ? "support-drop login-dropdown support-content-drp"
                : ""}` },
            React.createElement("div", { className: "drawerblock loginregister-drawer" },
                React.createElement("div", { className: device && device.isDesktop ? "drawer-body" : "drawer-body px-0" },
                    !userID ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "support-content-header" },
                            React.createElement("div", null,
                                React.createElement("span", { className: "edel-icon-support" })),
                            React.createElement("div", null,
                                React.createElement("span", { className: "DMSan_16_700 d-flex txt-hover" },
                                    React.createElement("a", { href: "tel:18001023335", className: "txt-hover" }, "18001023335")),
                                React.createElement("span", { className: "DMSansNormal_12_400 d-flex text-undeline txt-hover" },
                                    React.createElement("a", { href: "mailto:helpdesk@nuvama.com", className: "txt-hover" }, "helpdesk@nuvama.com"),
                                    " "))))) : (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "support-content-header-withid" },
                            React.createElement("span", { className: "d-flex" },
                                React.createElement("i", { className: "edel-icon-support-color" },
                                    " ",
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("span", { className: "DMSansMedium_18_500  ps-3 " },
                                    React.createElement("a", { href: "tel:18001023335", className: "txt-hover" }, "18001023335"))),
                            React.createElement("span", { className: "d-flex mgt-30" },
                                React.createElement("i", { className: "edel-icon-email1" },
                                    " ",
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" }),
                                    React.createElement("span", { className: "path3" }),
                                    React.createElement("span", { className: "path4" })),
                                React.createElement("span", { className: "DMSansMedium_18_500 ps-3 " },
                                    React.createElement("a", { href: "mailto:helpdesk@nuvama.com", className: "txt-hover" }, "helpdesk@nuvama.com"),
                                    " ")),
                            React.createElement("span", { className: "d-flex mgt-30" },
                                React.createElement("i", { className: "edel-icon-chat" },
                                    " ",
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("span", { className: "DMSansMedium_18_500  ps-3 txt-hover" }, "Chat with us"))))),
                    React.createElement("div", { className: "support-content-body" },
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("span", { className: "edel-icon-Account-Open icon" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("span", { className: "txt-hover" }, "Account Opening Status")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "edel-icon-loacte-us icon" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("span", { className: "txt-hover" }, "Locate Us")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "edel-icon-FAQ icon" },
                                    " ",
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" }),
                                    React.createElement("span", { className: "path3" }),
                                    React.createElement("span", { className: "path4" })),
                                React.createElement("span", { className: "txt-hover" }, "FAQs")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "edel-icon-EscalationMatrix icon" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("span", { className: "txt-hover" }, "Escalation Matrix")))))))));
};
export default SupportContent;
